module.exports = __webpack_public_path__ + "img/sign_in.2fc7559b.svg";